import 'babel-polyfill'

import Vue from 'vue'
// import './vuetify'
import vuetify from './plugins/vuetify';

import router from './router'
import store from './vuex'
import axios from './axios'

import errorHandling from './errorHandling.js'

import App from './App.vue'

import vueHeadful from 'vue-headful';
Vue.component('vue-headful', vueHeadful);

import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

import moment from 'moment'
import clone from 'clone'

Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$clone = clone;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
